import React, { useState } from 'react';
import Iconify from '../../../../Iconify';
import styles from './instructions.module.css';

export const InstructionsSpei = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleClose = () => {
    setIsExpanded(false);
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.triggerButton}
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <span className={styles.triggerText}>¿Cómo hacer la transferencia?</span>
        <Iconify
          icon={isExpanded ? 'material-symbols:keyboard-arrow-up' : 'material-symbols:keyboard-arrow-down'}
          className={styles.triggerIcon}
        />
      </button>

      {isExpanded && (
        <div className={styles.instructionsContainer}>
          <div className={styles.instructionsContent}>
            <h3 className={styles.instructionsTitle}>Instrucciones para realizar la transferencia</h3>
            
            <ol className={styles.stepsList}>
              <li className={styles.stepItem}>
                <span className={styles.stepNumber}>1</span>
                <span className={styles.stepText}>
                  Abre la aplicación móvil de tu banco e inicia sesión con tus credenciales.
                </span>
              </li>
              
              <li className={styles.stepItem}>
                <span className={styles.stepNumber}>2</span>
                <span className={styles.stepText}>
                  Busca la opción de "Transferencias" o "Pagos" en el menú principal.
                </span>
              </li>
              
              <li className={styles.stepItem}>
                <span className={styles.stepNumber}>3</span>
                <span className={styles.stepText}>
                  Selecciona "Transferencia SPEI" o "Transferencia interbancaria".
                </span>
              </li>
              <li className={styles.stepItem}>
                <span className={styles.stepNumber}>4</span>
                <span className={styles.stepText}>
                  Confirma la operación y tus fondos se reflejan de inmediato en tu cuenta.
                </span>
              </li>
            </ol>
          </div>

          <button
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Cerrar instrucciones"
          >
            <span className={styles.closeButtonText}>Cerrar instrucciones</span>
            <Iconify icon="material-symbols:close" className={styles.closeButtonIcon} />
          </button>
        </div>
      )}
    </div>
  );
};
